import React from 'react'
import PropTypes from 'prop-types'
import {Radio, Checkbox} from 'antd'

class VideoProduct extends React.Component {
  static propTypes = {
    product: PropTypes.object.isRequired,
    bundleProduct: PropTypes.object,
    productAvailability: PropTypes.object,
    onChange: PropTypes.func,
  }

  get variants() {
    return this.props.productAvailability.videoTypes.map(t => ({
      value: t.type,
      name: t.name,
      hasDroneOption: 'drone' in t.extraProductOptions,
      hasCreativeResourceOption: !!t.extraProductOptions.creativeResource,
      hasTeaserOption: 'teaser' in t.extraProductOptions,
    }))
  }

  get selectedVariant() {
    const variant = this.variants.find(v => v.value === this.props.product.videoVariant)
    return variant || this.variants[0]
  }

  onChange(changes) {
    if (changes.videoVariant) {
      const variant = this.variants.find(v => v.value === changes.videoVariant)
      if (variant) {
        if (!variant.hasDroneOption) changes.drone = false
        if (!variant.hasCreativeResourceOption) changes.creativeResource = false
        if (!variant.hasTeaserOption) changes.teaser = false
      }
    }

    this.props.onChange(changes)
  }

  render() {
    const canChangeVariant = !this.props.bundleProduct

    return (
      <div>
        {canChangeVariant && (
          <Radio.Group
            value={this.selectedVariant.value}
            onChange={e => this.onChange({videoVariant: e.target.value})}
            style={{marginBottom: 10}}
          >
            {
              this.variants.map(variant => (
                <Radio
                  key={variant.value}
                  value={variant.value}
                  style={{display: 'block'}}
                >
                  {variant.name}
                </Radio>
              ))
            }
          </Radio.Group>
        )}

        {this.selectedVariant.hasTeaserOption && (
          <div>
            <Checkbox
              checked={!!this.props.product.teaser}
              onChange={(e) => this.onChange({teaser: e.target.checked})}
            >
              Videovisning teaser
            </Checkbox>
          </div>
        )}

        {canChangeVariant && (
          <>
            <div>
              <Checkbox
                checked={this.props.product.drone}
                disabled={!this.selectedVariant.hasDroneOption}
                onChange={e => this.onChange({drone: e.target.checked})}
              >
                Drone
                <div>Drone vil bli benyttet i filmingen av video.</div>
              </Checkbox>
            </div>
            {this.selectedVariant.hasCreativeResourceOption && (
              <div>
                <Checkbox
                  checked={this.props.product.creativeResource}
                  onCheck={(e, value) => (this.onChange({creativeResource: value}))}
                >
                  Tekst og regi
                  <div>EFKT tar seg av alt forarbeidet ift. produksjon av video. EFKT vil innhente tekster og annen informasjon nødvendig for å produsere videoen.</div>
                </Checkbox>
              </div>
            )}
          </>
        )}
      </div>
    )
  }
}

export default VideoProduct
